export const formatNumber = (
  number: number,
  options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 1,
    notation: 'compact',
  },
) => {
  // get region from browser
  const region = Intl.DateTimeFormat().resolvedOptions().locale;

  return Intl.NumberFormat(region, options).format(number);
};
